import { Component, OnInit, Inject, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AliasService } from "src/providers/alias.service";
import { UserTypeModel } from "../../models/usertypes.model";
import { UserTypesService } from "src/providers/user-types.service";
import { FormsService } from "src/providers/forms.service";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ModalDefineUserTypeComponent } from "../modal-define-user-type/modal-define-user-type.component";
import { whitelist } from "@rxweb/reactive-form-validators";
import { ENV } from "src/environments/environment-variables.token";
import { UtilsProvider } from "../../commons/utils";
import { SessionStorageService } from "angular-web-storage";

export interface DialogData {
	title: string;
}
@Component({
	selector: "app-user-type",
	templateUrl: "./user-type.component.html",
	styleUrls: ["./user-type.component.scss", "../app.component.scss"],
	providers: []
})
export class UserTypeComponent implements OnInit {
	@Input() options: any;
	@Output() nextClick = new EventEmitter();
	public userTypesForm: any;
	public userTypesFormStep: any;
	public userForms: any;
	public roles: any;
	public fields: any;
	public form: any;
	public userTypes: any;
	public newUserType: any;
	public alias: any;
	public checkBoxList = [];
	public page = 0;
	public limit = 100;
	public selectedRole = [];
	public selectedForm = [];
	public flagInstitution: any;
	public selectedUserType: any;
	public userTypeformValues: any;
	private emailField = false;
	private phoneField = false;
	field: string;

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public formBuilder: FormBuilder,
		public aliasService: AliasService,
		public userTypeService: UserTypesService,
		public userTypeModel: UserTypeModel,
		public formsService: FormsService,
		public dialog: MatDialog,
		public utils: UtilsProvider,
		public sessionStorage: SessionStorageService,
		@Inject(ENV) public ENV: any,
	) { }
	ngAfterViewInit() {
		this.ENV.pageTitle = "Configuração de Tipo de Usuário";
	}
	async ngOnInit() {

		this.init();
	}
	async init() {
		const self = this;

		let err, fields, roles;
		this.flagInstitution = this.options;
		const instituitionSession = JSON.parse(localStorage.getItem("institution"));
		this.ENV.institutionRef = instituitionSession.institution_id;
		[err, roles] = await this.utils.tryCatch(this.aliasService.getAll({ page: this.page, perPage: this.limit }));
		if (err) {
			this.utils.toast({message: "Erro ao iniciar criação de tipo de usuário", action: "Ok", duration: 8000});
		}
		console.log('ROLES: ', roles)
		await this.getFields();

		this.userTypes = this.userTypeModel.get();
		// this.selectedRole = this.userTypes.rolesRef ? this.userTypes.rolesRef : [];
		// this.selectedForm = this.userTypes.formRef ? this.userTypes.formRef : [];
		this.route.queryParams.subscribe(async params => {
			this.newUserType = JSON.parse(params.newUserType);
			this.selectedUserType = params.selectedUserType;
			// if (!this.newUserType || this.newUserType  === false) {
			// 	const [err2, userSelected] = await this.utils.tryCatch(this.userTypeService.getByIdToEdit({ userTypeId: this.selectedUserType }));
			// 	if (err2) {
			// 		this.utils.toast({message: "Erro ao iniciar criação de tipo de usuário"});
			// 		// return this.router.navigate(["/pages/entrance"]);
			// 	}
			// 	this.selectedUserType = userSelected;
			// }
			if (this.selectedUserType) {

				const [err2, userSelected] = await this.utils.tryCatch(this.userTypeService.getByIdToEdit({ userTypeId: this.selectedUserType }));
				if (err2) {
						this.utils.toast({message: "Erro ao iniciar criação de tipo de usuário"});
						return this.router.navigate(["/pages/user-type-list"]);
					}
				this.selectedUserType = userSelected;
			}

			const _id = new FormControl("", undefined);
			const type = new FormControl("", Validators.compose([Validators.required]));
			const description = new FormControl("", Validators.compose([Validators.required]));
			const checkBoxList = new FormControl("", Validators.compose([Validators.required]));
			const fieldsList = new FormControl("", undefined);
			const adminApproval = new FormControl("", Validators.compose([Validators.required]));
			const isDefault = new FormControl("", Validators.compose([Validators.required]));
			const email = new FormControl("", undefined);
			const phone = new FormControl("", undefined);

			this.userTypesFormStep = 0;
			this.userTypesForm = [
				{
					fields: [
						{
							name: "_id",
							type: "hidden",
							blurCallback: () => { }
						},
						{
							name: "type",
							type: "text",
							required: true,
							placeholder: "Tipo",
							blurCallback: () => { },
							cols: "col-sm-12 col-md-6",
						},
						{
							name: "description",
							type: "text",
							required: true,
							placeholder: "Descrição",
							blurCallback: () => { },
							cols: "col-sm-12 col-md-6",
						},
						{
							name: "checkBoxList",
							type: "multiselect",
							required: true,
							placeholder: "Permissões de acesso",
							data: roles.items.map(alias => {
								const obj = {
									_id: alias._id,
									title: alias.description,
									description: alias.title,
								};
								return obj;
							}),
							change: (event, item) => {
								console.log("selected user types", item);
								this.checkBoxListChange(event, item);

							},
							control: this,
              cols: "col-sm-12 col-md-6",
						},
						{
							name: "fieldsList",
							type: "multiselect",
							required: true,
							placeholder: "Campos obrigatórios para acesso",
							data: this.fields,
							change: (event, item) => {
								console.log("selected user types", item);
								self.fieldsListChange(event, item);

							},
							control: this,
							cols: "col-sm-12 col-md-6",
						},
						{
							name: "adminApproval",
							type: "select2",
							placeholder: "Obrigatório aprovação do coordenador para criação/edição de usuários",
							required: true,
							options: {
								fields: {
									value: "value",
									text: "text"
								},
								items: [{ value: true, text: "Sim" }, { value: false, text: "Não" }]
							},
							clickCallback: () => {},
							cols: "col-sm-12 col-md-6",
						},
            {
							name: "isDefault",
							type: "select2",
							placeholder: "Exibir opção no app",
							required: true,
							options: {
								fields: {
									value: "value",
									text: "text"
								},
								items: [{ value: true, text: "Sim" }, { value: false, text: "Não" }]
							},
							clickCallback: () => {},
							cols: "col-sm-12 col-md-6",
						},
						// {
						// 	name: "email",
						// 	type: "checkbox2",
						// 	checkTitle: "Habilitar campo de e-mail",
						// 	cols: "col-md-6 col-sm-12 col-xs-12",
						// 	checked: this.emailField,
						// 	callback: () => {
						// 		this.emailField = !this.emailField;
						// 	}
						// },
						// {
						// 	name: "phone",
						// 	type: "checkbox2",
						// 	checkTitle: "Habilitar campo de telefone",
						// 	cols: "col-md-6 col-sm-12 col-xs-12",
						// 	checked: this.phoneField,
						// 	callback: () => {
						// 		this.phoneField = !this.phoneField;
						// 	}
						// },
					],
					builder: this.formBuilder.group({
						_id,
						type,
						description,
						adminApproval,
            isDefault,
						// rolesRef,
						// formRef,
						fieldsList,
						checkBoxList,
						// email,
						// phone
					}),
					validation_messages: {
						_id: [],
						type: [
							{ type: "required", message: "Campo não pode estar vazio." },
						],

						adminApproval: [
							{ type: "required", message: "Campo não pode estar vazio." },
						],
						isDefault: [
							{ type: "required", message: "Campo não pode estar vazio." },
						],
						description: [
							{ type: "required", message: "Campo não pode estar vazio." },
						],
						checkBoxList: [
							{ type: "required", message: "Campo não pode estar vazio." },
						],
						formRef: [
							{ type: "required", message: "Campo não pode estar vazio." },
						],
						fields: [],
						// email: [],
						// phone: []
					},
				},
			];

			if (this.selectedUserType) { this.setValue(); }
			if(this.userTypeformValues) this.userTypesForm[0].builder.patchValue(this.userTypeformValues);
		});
	}
	checkBoxListControl(alias) {
		this.checkBoxList.forEach((element) => {
			if (element.value === alias.value) { element.flag = !element.flag; }
			console.log("checkbox alias", alias);
		});
	}

	setFieldsOnForm() {
		// console.log(this.form.fields, id);
		const self = this;
		this.userTypeformValues = {...this.userTypesForm[0].builder.value}
		const dialogRef = this.dialog.open(ModalDefineUserTypeComponent, { data: {} });
		dialogRef.afterClosed().subscribe(result => {
			self.init();
		});
	}
	checkBoxListChange(event, item) {
		// this.getFields();
		if (event.isUserInput) {
			if (event.source.selected) {
				// this.onItemSelect(item);
			} else {
				// this.onItemDeSelect(item);
			}
		}
	}
	fieldsListChange(event, item) {
		// this.getFields();
		if (event.isUserInput) {
			if (event.source.selected) {
				// this.onItemSelect(item);
			} else {
				// this.onItemDeSelect(item);
			}
		}
	}
	setValue() {
		console.log("this.selectedUserType", this.selectedUserType);
		this.userTypesForm[0].builder.patchValue(this.selectedUserType);
	}
	getFields() {
		return new Promise(async (resolve, reject) => {

			const [err, fields] = await this.utils.tryCatch(this.formsService.getFields({ page: this.page, perPage: this.limit }));
			if (err || !fields) {
				this.utils.toast({message: "Erro ao iniciar criação de tipo de usuário"});
				reject(err);
			}
			console.log("FIELDS : ", fields);
			this.fields = fields.fields;
			return resolve(fields.fields);
		});

	}
	onSubmit(...args) {
		if (!this.userTypesForm[0].builder.valid) {
			return this.utils.toast({
				message: "Preencha todos os campos do formulário.",
				duration: 8000
			});
		}

		const data = { ...this.userTypesForm[0].builder.value };
		const fieldsdsIsValid = this.userTypeModel.getFields();

		if (fieldsdsIsValid.length >= 1) {
			data.fields = fieldsdsIsValid;
		}

		if (args[1] === "next") {
			this.nextClick.emit({ userType: [data] });
		} else {
			data.insituitionRef = this.ENV.institutionRef;
		}

		if (this.newUserType === true) {
			console.log("data2", data);
			this.userTypeService.createUserType(data).then(() => {
				this.router.navigate(["/pages/user-type-list"]);
			});
		} else {
			console.log("data4", data);
			this.userTypeService.updateUserType(data).then(() => {
				this.router.navigate(["/pages/user-type-list"]);
			});

		}
	}
}
